import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription, timer } from 'rxjs';
import { AddPlageComponent } from '../add-plage/add-plage.component';
import { AddTransportComponent } from '../add-transport/add-transport.component';
import { DeletePlageComponent } from '../delete-plage/delete-plage.component';
import { DeleteTransportComponent } from '../delete-transport/delete-transport.component';
import { UserService } from '../services/user.service';
import { ZoneService } from '../services/zone.service';
import { UpdateZoneComponent } from '../update-zone/update-zone.component';

@Component({
  selector: 'app-transports',
  templateUrl: './transports.component.html',
  styleUrls: ['./transports.component.scss']
})
export class TransportsComponent implements OnInit {
  subscription: Subscription;
  displayedColumns: string[] = ['zone','produit', 'minimum','maximum','camion','prix','action'];
    constructor(public userService:UserService,private zoneService:ZoneService,private dialog: MatDialog){}
 

  dataSource = new MatTableDataSource<PeriodicElement>(null);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  ngAfterViewInit() {
    

  }
  ngOnInit(): void {
    this.subscription =  timer(0, 3000).subscribe(res => {
      this.getAllOrders();
    });
  
  }


  
  getAllOrders() {
    this.zoneService.viewTransport(this.userService.getUserDetails()._id).subscribe((data: any) => {
      this.dataSource = new MatTableDataSource <PeriodicElement> (data); //pass the array you want in the table
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      return data
    })}


    addPlage(){
      this.dialog.open(AddTransportComponent, {
        width: '400px',
        height: '500px',
       
      })
    }
   
    updateZone(id){
      this.dialog.open(UpdateZoneComponent, {
        width: '400px',
        height: '380px',
        data: {id: id}
      })
    }
    deleteTransport(id){
      this.dialog.open(DeleteTransportComponent, {
       
        data: {id: id}
      })
    }

}
export interface PeriodicElement {
  zone: string;
  produit: string;
  minimum: string;
  maximum: string;
  camion_id: string;
  prix: string;
  action: string;
 
 
 
}
